import {StyleSheet} from 'aphrodite/no-important'

export const styles = StyleSheet.create({
    dialog_content: {
        display: "grid",
        gridTemplateRows: "min-content auto",
        width: "wrap-content",
        height: "wrap-content",
        maxHeight: "80vh",
        position: "absolute",
        fontFamily: "EncodeSans",
        borderRadius: "5px",
        z: "10",
        "box-shadow": " 0 10px 20px rgba(0,0,0,0.19), 0 6px 6px rgba(0,0,0,0.23);",
        ":focus" : {
            "outline-color": "transparent",
            "outline-style": "none",
        },
        backgroundColor: "transparent",
        overflow: "hidden",
        top: "50%",
        left: "50%",
        transform: "translate(-50%,-50%)",
        overflowY: "auto"
    },
    overlay: {
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        "z-index": "10",
        backgroundColor: "rgba(20, 20, 20, 0.8)",
        ":focus" : {
            "outline-color": "transparent",
            "outline-style": "none",
        },
    },
    dialog: {
        position: "fixed",
        top: "0",
        left: "0",
        right: "0",
        bottom: "0",
        z: "10",
        backgroundColor: "transparent",
        ":focus" : {
            "outline-color": "transparent",
            "outline-style": "none",
        },
    },
});



// WEBPACK FOOTER //
// ./src/components/dialogs/DialogStyle.ts